import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class OfflineAccountService extends BasicService {
    create(data) {
        return this.checkError(axios.post(this.API_URL + 'offline-account', data, { headers: authHeader() }));
    }

    changePassword(data) {
        return this.checkError(axios.post(this.API_URL + 'offline-account/change-password', data, { headers: authHeader() }));
    }

    changeEmail(data) {
        return this.checkError(axios.post(this.API_URL + 'offline-account/change-email', data,  { headers: authHeader() }));
    }

    verifyEmail(token) {
        return this.checkError(axios.post(this.API_URL + 'offline-account/verify-email', {token: token},  { headers: authHeader() }));
    }

    resendEmail() {
        return this.checkError(axios.post(this.API_URL + 'offline-account/resend-email', {},  { headers: authHeader() }));
    }

    deleteOfflineAccount() {
        return this.checkError(axios.delete(this.API_URL + 'offline-account',  { headers: authHeader() }));
    }

    getLogs() {
        return this.checkError(axios.get(this.API_URL + 'offline-account/logs', { headers: authHeader() }));
    }
}

export default new OfflineAccountService();